import React from 'react';

const FreeEvents = () => {
  return (
    <div className="pt-16 px-4 min-h-screen bg-background text-light">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold text-primary mb-8">Free Community Events</h1>
        
        {/* Hero Section */}
        <div className="bg-green-600 text-white p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-bold mb-2">🎉 COMPLETELY FREE DANCE EVENTS!</h2>
          <p className="text-lg mb-2">Best things in life should be free, like learning and dancing Salsa. That's why we're organizing a whole bunch of free community events this summer in Vancouver</p>
          <ul className="text-sm space-y-1">
            <li>• Weekly Friday events at Sun Hop Park</li>
            <li>• Special Sunday events in Gastown</li>
            <li>• All skill levels welcome - beginners encouraged!</li>
            <li>• No registration required</li>
          </ul>
        </div>
        
        {/* Regular Weekly Events */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-primary mb-6">Weekly Events</h2>
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between">
              <div className="flex-1">
                <h3 className="text-xl font-bold text-primary mb-2">Salsa in the Park</h3>
                <p className="text-secondary mb-4">SUN HOP PARK, 3333 MAIN ST, VANCOUVER</p>
                <div className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold mb-4 inline-block">
                  🎉 EVERY FRIDAY!
                </div>
                <ul className="list-disc list-inside mb-4 text-secondary">
                  <li>Intro Lesson: 7:00-7:30PM</li>
                  <li>Social Dancing: 7:30-9:00PM</li>
                </ul>
                <p className="text-sm text-secondary mb-4">
                  Perfect for newcomers and experienced dancers alike. Learn basic steps and enjoy dancing under open skies!
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6">
                <div className="bg-background p-4 rounded-lg">
                  <p className="text-light font-bold text-center mb-2">📍 Location</p>
                  <p className="text-secondary text-sm text-center">Sun Hop Park</p>
                  <p className="text-secondary text-sm text-center">3333 Main Street</p>
                  <p className="text-secondary text-sm text-center">Vancouver, BC</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Special Events */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-primary mb-6">Special Events</h2>
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-6">
              <div className="flex-1">
                <h3 className="text-xl font-bold text-primary mb-2">Salsa en la Calle</h3>
                <p className="text-secondary mb-4">100 WATER STREET, GASTOWN, VANCOUVER</p>
                <div className="bg-primary text-white px-3 py-1 rounded-full text-sm font-bold mb-4 inline-block">
                  ✨ SPECIAL SUNDAYS
                </div>
                <ul className="list-disc list-inside mb-4 text-secondary">
                  <li>Lesson with Fernanda & Rohana: 2:00-2:30PM</li>
                  <li>Social Dancing: 2:30-5:00PM</li>
                </ul>
                <p className="text-sm text-secondary mb-4">
                  Experience the vibrant energy of Salsa, Bachata, and Merengue in the heart of historic Gastown!
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6">
                <div className="bg-background p-4 rounded-lg">
                  <p className="text-light font-bold text-center mb-2">📍 Location</p>
                  <p className="text-secondary text-sm text-center">100 Water Street</p>
                  <p className="text-secondary text-sm text-center">Gastown</p>
                  <p className="text-secondary text-sm text-center">Vancouver, BC</p>
                </div>
              </div>
            </div>
            
            {/* Upcoming Dates */}
            <div className="border-t border-secondary border-opacity-20 pt-6">
              <h4 className="text-lg font-bold text-primary mb-4">Upcoming Dates</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-background p-4 rounded-lg">
                  <div className="text-center">
                    <p className="text-primary font-bold text-lg">Sunday, June 29</p>
                    <p className="text-light font-semibold">2025</p>
                    <p className="text-secondary text-sm mt-2">2:00PM - 5:00PM</p>
                  </div>
                </div>
                <div className="bg-background p-4 rounded-lg">
                  <div className="text-center">
                    <p className="text-primary font-bold text-lg">Sunday, August 3</p>
                    <p className="text-light font-semibold">2025</p>
                    <p className="text-secondary text-sm mt-2">2:00PM - 5:00PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Event Details */}
        <section className="mb-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">Event Information</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-bold text-secondary mb-2">🟠 FRIDAY - Salsa in the Park</h4>
                <p className="text-sm text-secondary mb-2">Sun Hop Park, 3333 Main St</p>
                <div className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold mb-2 inline-block">
                  WEEKLY EVENT
                </div>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• 7:00-7:30PM: Intro Lesson</li>
                  <li>• 7:30-9:00PM: Social Dancing</li>
                  <li>• Focus: Salsa & Bachata basics</li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-secondary mb-2">🔵 SUNDAY - Salsa en la Calle</h4>
                <p className="text-sm text-secondary mb-2">100 Water St, Gastown</p>
                <div className="bg-primary text-white px-2 py-1 rounded text-xs font-bold mb-2 inline-block">
                  SPECIAL EVENTS
                </div>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• 2:00-2:30PM: Lesson w/ Fernanda & Rohana</li>
                  <li>• 2:30-5:00PM: Social Dancing</li>
                  <li>• Styles: Salsa, Bachata, Merengue</li>
                </ul>
              </div>
            </div>
            <div className="border-t border-secondary border-opacity-20 pt-4 mt-6">
              <h4 className="font-bold text-secondary mb-2">Important Notes</h4>
              <ul className="space-y-2 text-secondary">
                <li>• All events are completely FREE</li>
                <li>• No registration required - just show up!</li>
                <li>• Bring water and comfortable shoes</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>    
  );
};

export default FreeEvents;